import { SVGProps } from 'react';

export type EmptyWindowProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const EmptyWindow = ({ size = 51, ...props }: EmptyWindowProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.8">
      <path
        d="M46.0352 16.1689L46.0352 36.1484C46.0351 38.5373 44.0979 40.4736 41.709 40.4736L9.37109 40.4736C6.98218 40.4736 5.04495 38.5373 5.04492 36.1484L5.04492 16.1689C5.04492 13.78 6.98217 11.8428 9.37109 11.8428L41.709 11.8428C44.0979 11.8428 46.0352 13.78 46.0352 16.1689Z"
        fill="white"
        stroke="#666666"
        strokeWidth="1.44184"
      />
      <path
        d="M46.0352 12.9766C46.0352 13.6021 45.5279 14.1092 44.9023 14.1094L6.17871 14.1094C5.55304 14.1094 5.04492 13.6022 5.04492 12.9766C5.04508 12.351 5.55313 11.8437 6.17871 11.8437L44.9023 11.8437C45.5278 11.8439 46.035 12.3511 46.0352 12.9766Z"
        fill="#E5E5E5"
        stroke="#666666"
        strokeWidth="1.44184"
      />
      <path
        d="M9.55566 12.9775C9.5555 13.1364 9.42645 13.2646 9.26758 13.2646L7.62012 13.2646C7.46125 13.2646 7.3322 13.1364 7.33203 12.9775C7.33203 12.8186 7.46115 12.6895 7.62012 12.6895L9.26758 12.6895C9.42655 12.6895 9.55566 12.8186 9.55566 12.9775Z"
        fill="#F2F3F4"
        stroke="#666666"
        strokeWidth="1.07214"
      />
      <path
        d="M13.8818 12.9775C13.8817 13.1364 13.7526 13.2646 13.5937 13.2646L11.9463 13.2646C11.7874 13.2646 11.6584 13.1364 11.6582 12.9775C11.6582 12.8186 11.7873 12.6895 11.9463 12.6895L13.5937 12.6895C13.7527 12.6895 13.8818 12.8186 13.8818 12.9775Z"
        fill="#F2F3F4"
        stroke="#666666"
        strokeWidth="1.07214"
      />
      <path
        d="M18.208 12.9775C18.2078 13.1364 18.0788 13.2646 17.9199 13.2646L16.2725 13.2646C16.1136 13.2646 15.9845 13.1364 15.9844 12.9775C15.9844 12.8186 16.1135 12.6895 16.2725 12.6895L17.9199 12.6895C18.0789 12.6895 18.208 12.8186 18.208 12.9775Z"
        fill="#F2F3F4"
        stroke="#666666"
        strokeWidth="1.07214"
      />
      <circle
        opacity="0.34"
        cx="25.3749"
        cy="27.0917"
        r="8.43937"
        fill="#EAEAEA"
      />
      <g opacity="0.8">
        <path
          d="M25.4922 31.4974L29.0086 29.4699L27.6598 28.6923L26.2814 29.4867C26.2697 29.4933 26.2565 29.4967 26.243 29.4966C26.2296 29.4965 26.2164 29.4929 26.2047 29.4862C26.1931 29.4794 26.1834 29.4698 26.1766 29.4582C26.1699 29.4466 26.1662 29.4334 26.1661 29.42V27.5316C26.1661 27.5045 26.1732 27.4779 26.1867 27.4545C26.2003 27.4311 26.2198 27.4117 26.2433 27.3982L27.8808 26.4539C27.8926 26.4472 27.9058 26.4438 27.9193 26.4439C27.9328 26.4439 27.9461 26.4475 27.9578 26.4542C27.9695 26.461 27.9792 26.4706 27.986 26.4823C27.9928 26.4939 27.9965 26.5071 27.9966 26.5206V28.1092L29.3452 28.8868V24.832L25.4922 27.0537V31.4974Z"
          fill="#434343"
        />
        <path
          d="M25.8294 22.8047V24.36L27.2071 25.1544C27.2187 25.1612 27.2283 25.171 27.235 25.1826C27.2416 25.1943 27.2451 25.2075 27.2451 25.221C27.2451 25.2344 27.2416 25.2476 27.235 25.2593C27.2283 25.271 27.2187 25.2807 27.2071 25.2876L25.5696 26.2319C25.5461 26.2454 25.5195 26.2525 25.4924 26.2525C25.4653 26.2525 25.4386 26.2454 25.4151 26.2319L23.7774 25.2885C23.7658 25.2816 23.7562 25.2719 23.7496 25.2602C23.7429 25.2485 23.7394 25.2353 23.7394 25.2218C23.7394 25.2083 23.7429 25.1951 23.7496 25.1834C23.7562 25.1717 23.7658 25.162 23.7774 25.1551L25.1551 24.361V22.8047L21.6387 24.8322L25.4921 27.0539L29.3456 24.8322L25.8294 22.8047Z"
          fill="#434343"
        />
        <path
          d="M24.7029 29.4869L23.3245 28.6923L21.976 29.4699L25.4921 31.4974V27.0537L21.6387 24.832V28.8868L22.9874 28.1092V26.5203C22.9876 26.5069 22.9913 26.4938 22.9982 26.4822C23.005 26.4706 23.0147 26.461 23.0263 26.4543C23.038 26.4476 23.0512 26.4441 23.0646 26.444C23.0781 26.4439 23.0913 26.4473 23.103 26.4539L24.7417 27.3982C24.7652 27.4117 24.7846 27.4311 24.7981 27.4545C24.8117 27.478 24.8187 27.5046 24.8187 27.5316V29.42C24.8186 29.4335 24.8151 29.4468 24.8083 29.4585C24.8015 29.4702 24.7918 29.4799 24.78 29.4867C24.7683 29.4935 24.755 29.497 24.7415 29.4971C24.728 29.4971 24.7146 29.4936 24.7029 29.4869Z"
          fill="#434343"
        />
      </g>
    </g>
  </svg>
);
